// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","326":"cadastrar"}[chunkId] || chunkId) + "." + {"94":"a933b903","326":"fa9e0e69","354":"e9d95382","418":"f1d3d256","668":"eee781f8","815":"784867d8"}[chunkId] + ".js";
};